import React from "react";
import { Link } from "react-router-dom";
import SearchBar from "../../modules/Button/SearchBar";

const HeaderNav = () => {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        background: "#222",
        color: "#fff",
        position: "sticky",
        top: 0,
        zIndex: 100,
        flexdirection: "row",
        boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
         flexWrap: "nowrap", 
      }}
    >
      {/* 左側ロゴ + 下部リンク一覧 */}
      <div
        style={{
          display: "flex",
          flexDirection: "column", // 縦方向に並べる
          width: "100%",
        }}
      >
        {/* 上段: ロゴ */}
        <div>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "18px",
              fontWeight: "bold",
              textDecoration: "none",
              background: "linear-gradient(90deg, #8be9fd, #ffffff)", // 水色→白グラデーション
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              transition: "transform 0.2s ease, text-shadow 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.1)";
              e.currentTarget.style.textShadow =
                "0 0 8px rgba(255, 255, 255, 0.8)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.textShadow = "none";
            }}
          >
            <img
              src="/siteicon.PNG"
              alt="Mind Threat ロゴ"
              style={{
                width: "24px",
                height: "24px",
                transition: "transform 0.2s ease",
              }}
            />
            Mind Threat
          </Link>
        </div>

        {/* 下段: リンク一覧 */}
        <nav style={{ display: "flex", gap: "15px", marginTop: "5px" }}>
          {[
          { to: "/", label: "ホーム" },
            { to: "/library", label: "図書館" },
            { to: "/create", label: "新規作成" },
            { to: "/about", label: "このサイトについて" },
          ].map((link) => (
            <Link
              key={link.to}
              to={link.to}
              style={{
                fontWeight: "bold",
                textDecoration: "none",
                background: "linear-gradient(90deg, #8be9fd, #ffffff)", // 上段と統一
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                transition: "transform 0.2s ease, text-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.1)";
                e.currentTarget.style.textShadow =
                  "0 0 8px rgba(255, 255, 255, 0.8)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.textShadow = "none";
              }}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      {/* 右側検索バー */}
      <div
        style={{
          width: "250px",
          
        }}
      >
        <SearchBar />
      </div>
    </header>
  );
};

export default HeaderNav;
